<mat-form-field class="dict-contracts">
  <mat-label>{{ label }}</mat-label>
  <mat-select [formControl]="control" [required]="required" (selectionChange)="onSelectionChange($event)" [multiple]="multiple">
    <mat-option *ngFor="let contract of items" [value]="contract.uuid" multiLineOption>
      <h4 mat-line>
        <ng-container *ngIf="contract.partner">
          {{contract.partner?.shortName}},
        </ng-container>
        <ng-container *ngIf="contract.ofwca">
          {{contract.ofwca.fullName}},
        </ng-container>
        {{ contract.type.name }} (nr: {{contract.number}})
      </h4>
      <p mat-line>
        Zawarta {{contract.concludeDate | date:'y-MM-dd'}},
        Status: {{contract.status.name}}
      </p>
      <p mat-line>
        Firma: {{contract.company.name}}
      </p>
    </mat-option>
  </mat-select>
  <button *ngIf="((control.value !== null
    && multiple && control.value.hasOwnProperty('length')
    && control.value.length > 0) || (!multiple && control.value))
    && !required"
          matSuffix
          mat-icon-button
          type="button"
          aria-label="Clear"
          (click)="clearValue(); $event.stopPropagation()">
    <mat-icon>close</mat-icon>
  </button>
  <mat-error *ngIf="control.hasError('required')">To pole jest wymagane</mat-error>
  <mat-error *ngIf="control.hasError('backendError')">{{control.getError('backendError')}}</mat-error>
</mat-form-field>
